import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 font-['Inter'] w-full max-w-lg mx-auto relative overflow-hidden">
      {/* Full-screen fixed background */}
      <img
        src="/auth-background.svg"
        alt="auth background"
        className="fixed inset-0 z-50 object-cover w-full h-full pointer-events-none"
        style={{
          filter: 'brightness(0.97)',
        }}
      />

      {/* Card container must be above background */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, type: 'spring', damping: 25, stiffness: 120 }}
        className="relative z-10 w-full"
      >
        <div className="mb-8 text-center">
          <img
            src="/icons/brand/revi/monogram-black.svg"
            alt="revi-logo"
            className="w-10 h-10 mx-auto mb-4"
          />
          {title && <h1 className="mb-2 text-3xl font-medium text-neutral-950">{title}</h1>}
          {subtitle && <p className="text-sm text-neutral-600">{subtitle}</p>}
        </div>

        <div className="px-8 rounded-2xl">{children}</div>
      </motion.div>
    </div>
  );
}
